.payment-details-section {
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
  border-top: 1px solid var(--color-grayscale-tuna);
}

.payment-details-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-details-title {
  color: var(--color-grayscale-light-slate);
}

.payment-date {
  color: var(--color-grayscale-white);
  font-size: 1.4rem;
  font-weight: 500;
}
